/* tslint:disable */
/* eslint-disable */
export enum PatchLotConflictType {
  CannotWithdrawLotWithAcceptedPrebids = 'cannot_withdraw_lot_with_accepted_prebids'
}
